import modalNegative from "../../../assets/sounds/effects/ModalNegative.mp3";
import { useSound } from "./useSound";

export const soundModalNegative = () => {
  const sound = useSound({src:modalNegative});

  sound.play();
};
